import { createFileRoute } from "@tanstack/react-router";

import Staff from "@/components/Staff/Staff";

export const Route = createFileRoute("/gym/$venueUuid/staff")({
  component: () => <Staff />,
});
